// App.js

import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import 'bootstrap/dist/css/bootstrap.min.css';
import FetchVPCDetails from './components/FetchVPCDetails';
import AllRequests from './components/AllRequests';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Amplify } from 'aws-amplify';

import { withAuthenticator } from '@aws-amplify/ui-react';

import '@aws-amplify/ui-react/styles.css';

import config from './amplifyconfiguration.json';
import Button from 'react-bootstrap/Button';

Amplify.configure(config);



function App({ signOut, user }) {

  return (
    <div>
      <Navbar className="bg-body-tertiary">
      <Container>
        <Navbar.Brand href="#home">Artifactory VPC TGW migration</Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          
          <Row>
            <Col xs={6}>
          <Navbar.Text>
            Signed in as: <a href="#login">{user.username}</a>
          
          </Navbar.Text>
          </Col>
          <Col>
          <Button onClick={signOut}>Sign out</Button>
          </Col>
          </Row>
        </Navbar.Collapse>
      </Container>
    </Navbar>


    
    <Tabs
      defaultActiveKey="Fetch VPC"
      id="uncontrolled-tab-example"
      className="mb-3"
    >
      <Tab eventKey="Fetch VPC" title="Fetch VPC">
      <FetchVPCDetails  user={user.username}/>
      </Tab>
      <Tab eventKey="All Requests" title="All Requests">
      <AllRequests />
      </Tab>
      
    </Tabs>

      
        
    </div>
  
  );
}

export default withAuthenticator(App);
